module.exports = __webpack_public_path__ + "static/media/fancyspiralledtubers.d88160d5.png";